import { DefaultTheme } from 'styled-components';

const locales: DefaultTheme['components']['select']['locales'] = {
	en: {
		remove_all_btn: 'Remove all',
		no_results: 'No results',
		save_btn: 'Save'
	},
	es: {
		remove_all_btn: 'Borrar selección',
		no_results: 'No hay resultados',
		save_btn: 'Guardar'
	},
	it: {},
	fr: {},
	'es-MX': {}
};

export default locales;
